import { ReactElement } from 'react';
import {
  Accordion as MantineAccordion,
  AccordionControlProps,
  AccordionPanelProps,
  AccordionProps,
  Center,
} from '@mantine/core';

import styles from './accordian.module.scss';

type AccordionType = AccordionProps & {
  children: React.ReactNode;
  dataTestId?: string;
  isMultiple?: boolean;
  title: string;
};

type HeaderType = AccordionControlProps & {
  actions?: ReactElement;
  children: ReactElement | string;
};

type BodyType = AccordionPanelProps & {
  children: ReactElement | string;
};

const Header = ({ actions, children, ...props }: HeaderType) => (
  <Center>
    <MantineAccordion.Control {...props}>{children}</MantineAccordion.Control>
    {actions}
  </Center>
);

const Body = ({ children, ...props }: BodyType) => (
  <MantineAccordion.Panel {...props}>{children}</MantineAccordion.Panel>
);

export const Accordion = ({
  children,
  title,
  isMultiple = false,
  ...props
}: AccordionType) => {
  return (
    <MantineAccordion {...props}>
      <MantineAccordion.Item
        value={title}
        className={!isMultiple ? styles['single-item'] : ''}
      >
        {children}
      </MantineAccordion.Item>
    </MantineAccordion>
  );
};

Accordion.Header = Header;
Accordion.Body = Body;
